module.exports = __webpack_public_path__ + "img/btn01.13bb5751.svg";